// What an activation code looks like, in one place.
//
// The flow used to live under `/s/:code`, where the `s` segment was what told
// the router "the next segment is a session, not a page". The code now sits at
// the root (`/ABCD12`), which is shorter to read off a table and to say out
// loud — and which means a bare `/:code` route would otherwise match every
// path the app has, including ones it should not answer for.
//
// So the shape does the job the prefix used to: four to six letters or digits,
// nothing else.
//
// Deliberately NOT the generator's own alphabet. It builds codes from
// `ABCDEFGHJKLMNPQRSTUVWXYZ23456789` — no I, O, 0 or 1, because those are
// misread aloud and mistyped — but the admin wizard's code field is a plain
// text input, so a hand-typed activation can contain any of them. Matching the
// generator would have turned a real session's link into a redirect to the
// entry form, which is a worse failure than the one this guard prevents.
//
// What it does catch is everything that is not code-SHAPED: a dot, a slash, a
// hyphen, anything too short or too long. That covers static paths that slip
// past the SPA rewrite and the accidental deep link.
//
// This does not prove a code EXISTS. It only separates "this could be a code,
// go and ask the server" from "this is not a code, go back to the entry
// screen", which is the decision the router has to make before any fetch.
const CODE_PATTERN = /^[A-Za-z0-9]{4,6}$/;

/** True when `value` could be an activation code. */
export function looksLikeActivationCode(value) {
  return typeof value === 'string' && CODE_PATTERN.test(value);
}

export { CODE_PATTERN };
